module.exports = __webpack_public_path__ + "db9c1315f4b9b85192bc4166ee93c7c0.svg";